module.exports = __webpack_public_path__ + "img/whatsapp.98f106f3.svg";